if (!customElements.get('gm-market-chart')) {
 class GMMarketChart extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.select = this.querySelector('[data-market-select]');
   this.host = this.querySelector('[data-chart-host]');
   this.root = this.closest('gm-economic-dashboard');
   this.select.addEventListener('change', () => this.openChart(), { signal });
   this.querySelector('[data-chart-retry]').addEventListener('click', () => this.openChart(), { signal });
   this.root.addEventListener('click', event => {
    const button = event.target.closest('[data-open-market]');
    if (!button || !this.root.contains(button)) return;
    const value = button.dataset.openMarket;
    if (![...this.select.options].some(option => option.value === value)) return;
    this.select.value = value;
    this.openChart();
    this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    this.select.focus({ preventScroll: true });
   }, { signal });
   this.openChart();
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
   clearTimeout(this.timeout);
  }
  status(state) {
   this.querySelectorAll('[data-chart-message]').forEach(el => el.hidden = el.dataset.chartMessage !== state);
   this.dataset.state = state;
  }
  openChart() {
   this.observer?.disconnect();
   clearTimeout(this.timeout);
   const option = this.select.selectedOptions[0];
   this.querySelectorAll('[data-market-info]').forEach(el => el.hidden = el.dataset.marketInfo !== option.value);
   this.querySelector('a[data-provider-link]').href = option.dataset.providerLink;
   this.host.hidden = option.dataset.unavailable === 'true';
   this.querySelector('[data-chart-retry]').hidden = this.host.hidden;
   this.host.replaceChildren();
   if (this.host.hidden) { this.generation = (this.generation || 0) + 1; this.status('restricted'); return; }
   this.status('loading');
   const container = document.createElement('div');
   container.className = 'tradingview-widget-container';
   container.style.height = '100%';
   container.style.width = '100%';
   const widget = document.createElement('div');
   widget.className = 'tradingview-widget-container__widget';
   widget.style.height = 'calc(100% - 32px)';
   widget.style.width = '100%';
   const attribution = document.createElement('div');
   attribution.className = 'tradingview-widget-copyright';
   const link = document.createElement('a');
   link.href = option.dataset.providerLink;
   link.target = '_blank';
   link.rel = 'noopener nofollow';
   const label = document.createElement('span');
   label.className = 'blue-text';
   label.textContent = option.value + ' chart';
   link.append(label);
   const trademark = document.createElement('span');
   trademark.className = 'trademark';
   trademark.textContent = ' by TradingView';
   attribution.append(link, trademark);
   container.append(widget, attribution);
   this.host.append(container);
   const generation = (this.generation || 0) + 1;
   this.generation = generation;
   this.observer = new MutationObserver(() => {
    const frame = container.querySelector('iframe');
    if (!frame || frame.dataset.gmObserved) return;
    frame.dataset.gmObserved = 'true';
    frame.title = option.value + ' chart by TradingView (English)';
    frame.addEventListener('load', () => {
     if (this.generation !== generation || !this.isConnected) return;
     clearTimeout(this.timeout);
     this.status('frame');
    }, { once: true, signal: this.abort.signal });
   });
   this.observer.observe(container, { childList: true, subtree: true });
   const script = document.createElement('script');
   script.type = 'text/javascript';
   script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
   script.async = true;
   script.textContent = JSON.stringify({
    autosize: true, symbol: option.value, interval: 'D', timezone: 'Etc/UTC',
    theme: 'light', style: '1', locale: 'en', allow_symbol_change: false,
    calendar: false, details: false, hide_side_toolbar: true,
    hide_top_toolbar: false, hide_legend: false, hide_volume: true,
    save_image: false, withdateranges: true, backgroundColor: '#ffffff',
    gridColor: 'rgba(46, 46, 46, 0.06)', watchlist: [], compareSymbols: [], studies: []
   });
   script.addEventListener('error', () => {
    if (this.generation === generation) this.status('unavailable');
   }, { once: true, signal: this.abort.signal });
   container.append(script);
   this.timeout = setTimeout(() => {
    if (this.generation === generation && this.dataset.state !== 'frame') this.status('unavailable');
   }, 20000);
  }
 }
 customElements.define('gm-market-chart', GMMarketChart);
}
